import { gql, useQuery } from "@apollo/client";
import wpClient from "../../../../ugg/src/lib/wp-client";

type StickyNewsBannerProps = {
  className?: string;
  linkText?: string;
  showWhileLoading?: boolean;
  suppressErrors?: boolean;
};

const GET_TIER_LIST_NEWS_BANNER = gql`
  query getMainSiteOptions {
    mainSiteOptions {
      mainSiteOptions {
        tierListColoredLabel
        tierListRemixIconClass
        tierListStickyExcerpt
        tierListStickyLabelIconBorderColor
        tierListStickyUrl
      }
    }
  }
`;

export default function StickyNewsBanner({
  className,
  linkText = "Read More",
  showWhileLoading = false,
  suppressErrors = true,
}: StickyNewsBannerProps) {
  const { data, loading, error } = useQuery(GET_TIER_LIST_NEWS_BANNER, {
    client: wpClient,
  });

  if (loading && !showWhileLoading) return null;
  if (error && suppressErrors) return null;

  const opts = data?.mainSiteOptions?.mainSiteOptions;
  const label = opts?.tierListColoredLabel;
  const url = opts?.tierListStickyUrl;

  // If required bits are missing, don’t render anything
  if (!label || !url) return null;

  const iconClass = opts?.tierListRemixIconClass;
  const excerpt = opts?.tierListStickyExcerpt;
  const color = opts?.tierListStickyLabelIconBorderColor as string | undefined;

  return (
    <a href={url} className="link-whole">
      <div className={`sticky-section tier-list ${className ?? ""}`} style={{ border: color ? `1px solid ${color}` : undefined }}>
        <div className="sticky-item-wrapper">
          <div className="left-side">
            {iconClass && <i className={iconClass} style={{ color }} />}
            <div className="sticky-text-label" style={{ color }}>
              <p>{label}</p>
            </div>
          </div>
          <div className="sticky-text">
            <p>{excerpt}</p>
          </div>
        </div>
        <div className="sticky-url">
          <button>
            <p>{linkText}</p>
            <i className="ri-arrow-right-s-line"></i>
          </button>
        </div>
      </div>
    </a>
  );
}
